import { c as _c } from "react/compiler-runtime";
import { faUser } from '@fortawesome/pro-regular-svg-icons';
import { useLocationId } from '../../hooks';
import React from 'react';
import { Form } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import { useSearchParams } from 'react-router-dom';
import axios from 'shared/anaxios';
import { Avatar } from 'shared/avatar';
import Button from 'shared/button';
import Callout from 'shared/callout';
import { InputComponent } from 'shared/dynamic-fields/form-renderer';
import { Box, Flex, Grid } from 'shared/grid';
import Modal, { CloseButton } from 'shared/modal';
import settings from 'shared/settings';
import { CroppedText, Heading, Text } from 'shared/typography';
import { CLIENT_REQUEST_TYPES, EMPTY_OBJECT } from 'shared/utils/constants';
import { getCdnImageUrlFromId } from 'shared/utils/images';
import { useAppSelector } from '../../store';
import { BookStepHeading } from '../shared';
const RequestPrescriptionView = () => {
  const $ = _c(47);
  const [searchParams, setSearchParams] = useSearchParams();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [{
      label: "Firstname",
      name: "client.firstname",
      type: "textline",
      required: true
    }, {
      label: "Lastname",
      name: "client.lastname",
      type: "textline",
      required: true
    }, {
      label: "Email",
      name: "client.email",
      type: "email",
      required: true
    }, {
      label: "Cellphone",
      name: "client.cellphone",
      type: "phone-number",
      required: true
    }, {
      label: "Description",
      name: "description",
      type: "textarea",
      required: true
    }];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const formSchema = t0;
  const token = useAppSelector(_temp);
  const businessId = useAppSelector(_temp2);
  const [locationId] = useLocationId();
  let t1;
  if ($[1] !== locationId) {
    t1 = state_1 => state_1.locations.data[locationId];
    $[1] = locationId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const location = useAppSelector(t1);
  const timezone = location?.timezone;
  const language = useAppSelector(_temp3);
  const [isSubmitted, setIsSubmitted] = React.useState(false);
  const [openBookableId, setOpenBookableId] = React.useState(null);
  const bookableData = useAppSelector(_temp4);
  let t2;
  if ($[3] !== bookableData || $[4] !== locationId) {
    t2 = Object.values(bookableData).filter(_temp5).filter(b_0 => b_0.location_ids.includes(locationId)).filter(_temp6);
    $[3] = bookableData;
    $[4] = locationId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const locationBookables = t2;
  let t3;
  if ($[6] !== setSearchParams) {
    t3 = bid => {
      setSearchParams(prev => ({
        ...Object.fromEntries(prev.entries()),
        bid
      }));
    };
    $[6] = setSearchParams;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const setBookableId = t3;
  let t4;
  if ($[8] !== searchParams) {
    t4 = searchParams.get("bid");
    $[8] = searchParams;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const bookableId = t4;
  const openBookable = bookableData[openBookableId];
  let t5;
  if ($[10] !== setBookableId) {
    t5 = bid_0 => {
      setOpenBookableId(null);
      setBookableId(bid_0);
    };
    $[10] = setBookableId;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const select = t5;
  if (bookableId === null) {
    const t6 = "/" + (locationId ? `?lid=${locationId}` : "");
    let t7;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <FormattedMessage id="Public.BookView.selectServicePrompt" defaultMessage={"Select \"Resource\""} />;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    let t8;
    if ($[13] !== t6) {
      t8 = <BookStepHeading backTo={t6}>{t7}</BookStepHeading>;
      $[13] = t6;
      $[14] = t8;
    } else {
      t8 = $[14];
    }
    let t9;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = ["repeat( auto-fit, minmax(150px, 1fr) )"];
      $[15] = t9;
    } else {
      t9 = $[15];
    }
    let t10;
    if ($[16] !== bookableData || $[17] !== locationBookables || $[18] !== select) {
      t10 = <Grid gridTemplateColumns={t9} justifyItems="center">{locationBookables.map(t11 => {
          const {
            name,
            id: bid_1
          } = t11;
          return <Grid onClick={() => select(bid_1)} onKeyPress={e => e.key === "Enter" && select(bid_1)} tabIndex={0} role="button" key={bid_1} sx={{
            cursor: "pointer"
          }} justifyItems="center"><Avatar size={100} image={bookableData[bid_1]?.image_id ? getCdnImageUrlFromId(bookableData[bid_1].image_id) : null} icon={faUser} name={name} /><Grid gridGap={2}><Heading fontWeight={500} fontSize={3} textAlign="center">{name}</Heading>{bookableData[bid_1]?.description && <Flex justifyContent="center"><Button onClick={e_0 => {
                  e_0.stopPropagation();
                  setOpenBookableId(bid_1);
                }} as="button" type="button" color="primary" variant="outlined" size="small"><FormattedMessage id="About" defaultMessage="About" /></Button></Flex>}</Grid></Grid>;
        })}</Grid>;
      $[16] = bookableData;
      $[17] = locationBookables;
      $[18] = select;
      $[19] = t10;
    } else {
      t10 = $[19];
    }
    const t11 = !!openBookableId;
    let t12;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = () => setOpenBookableId(null);
      $[20] = t12;
    } else {
      t12 = $[20];
    }
    const t13 = openBookable || EMPTY_OBJECT;
    let t14;
    if ($[21] !== t13) {
      t14 = {
        openBookable: t13
      };
      $[21] = t13;
      $[22] = t14;
    } else {
      t14 = $[22];
    }
    let t15;
    if ($[23] !== openBookableId || $[24] !== select) {
      t15 = t16 => {
        const {
          openBookable: openBookable_0,
          close
        } = t16;
        return <Grid borderRadius={2} p={4} gridGap={8}><Box sx={{
            position: "absolute",
            top: 0,
            right: 0
          }} p={4}><CloseButton isDark={true} onClick={close} /></Box><Grid><Flex justifyContent="center"><Avatar size={150} image={openBookable_0.image_id ? getCdnImageUrlFromId(openBookable_0.image_id) : null} name={openBookable_0.name} /></Flex><Flex justifyContent="center"><Box sx={{
                overflow: "hidden",
                display: "-webkit-box",
                overflowWrap: "break-word",
                WebkitLineClamp: 1,
                WebkitBoxOrient: "vertical"
              }}><Text fontSize={3} fontFamily="heading">{openBookable_0.name}</Text></Box></Flex></Grid><Grid>{openBookable_0.description.split("\n").map(_temp7)}</Grid><Flex justifyContent="flex-end"><Button variant="flat" mr={2} onClick={close}>Close</Button><Button onClick={() => select(openBookableId)}>Select</Button></Flex></Grid>;
      };
      $[23] = openBookableId;
      $[24] = select;
      $[25] = t15;
    } else {
      t15 = $[25];
    }
    let t16;
    if ($[26] !== t11 || $[27] !== t14 || $[28] !== t15) {
      t16 = <Modal isOpen={t11} close={t12} size="medium" props={t14} autoFocus={false}>{t15}</Modal>;
      $[26] = t11;
      $[27] = t14;
      $[28] = t15;
      $[29] = t16;
    } else {
      t16 = $[29];
    }
    let t17;
    if ($[30] !== t10 || $[31] !== t16 || $[32] !== t8) {
      t17 = <Grid gridGap={8}>{t8}{t10}{t16}</Grid>;
      $[30] = t10;
      $[31] = t16;
      $[32] = t8;
      $[33] = t17;
    } else {
      t17 = $[33];
    }
    return t17;
  }
  let t6;
  if ($[34] !== bookableId || $[35] !== businessId || $[36] !== language || $[37] !== locationId || $[38] !== timezone || $[39] !== token) {
    t6 = values => {
      const requestBody = {
        request_type: CLIENT_REQUEST_TYPES.document,
        description: values.description,
        client: {
          ...values.client,
          language,
          timezone
        },
        business_id: businessId,
        location_id: locationId,
        bookable_id: bookableId
      };
      if (businessId) {
        axios.post(`${settings.api2Root}/client-requests`, requestBody, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }).then(response => setIsSubmitted(true));
      }
    };
    $[34] = bookableId;
    $[35] = businessId;
    $[36] = language;
    $[37] = locationId;
    $[38] = timezone;
    $[39] = token;
    $[40] = t6;
  } else {
    t6 = $[40];
  }
  let t7;
  if ($[41] !== isSubmitted || $[42] !== locationId) {
    t7 = t8 => {
      const {
        handleSubmit,
        submitting
      } = t8;
      return <Grid><BookStepHeading backTo={"/" + (locationId ? `?lid=${locationId}` : "")}>{isSubmitted ? "" : "Prescription request details"}</BookStepHeading>{isSubmitted ? <Callout color="green" mx={0}><FormattedMessage id="Public.RequestPrescription.requestSubmitted" defaultMessage="Your prescription request has been submitted" /></Callout> : <Grid as="form" onSubmit={handleSubmit}>{formSchema.map(_temp8)}<Flex justifyContent="flex-end"><Button type="submit" loading={submitting} disabled={submitting}><FormattedMessage id="Public.FormView.submitButton" defaultMessage="Submit" /></Button></Flex></Grid>}</Grid>;
    };
    $[41] = isSubmitted;
    $[42] = locationId;
    $[43] = t7;
  } else {
    t7 = $[43];
  }
  let t8;
  if ($[44] !== t6 || $[45] !== t7) {
    t8 = <Form onSubmit={t6}>{t7}</Form>;
    $[44] = t6;
    $[45] = t7;
    $[46] = t8;
  } else {
    t8 = $[46];
  }
  return t8;
};
export default RequestPrescriptionView;
function _temp(state) {
  return state.session.token;
}
function _temp2(state_0) {
  return state_0.public.businessId;
}
function _temp3(state_2) {
  return state_2.userPreferences.language;
}
function _temp4(state_3) {
  return state_3.bookables.data;
}
function _temp5(b) {
  return b.is_deleted == false;
}
function _temp6(b_1) {
  return !!b_1.staff_member_id;
}
function _temp7(v, idx) {
  return <CroppedText key={idx} data-sentry-element="CroppedText" data-sentry-component="_temp7" data-sentry-source-file="component.tsx">{v}</CroppedText>;
}
function _temp8(inputSchema, idx_0) {
  return <InputComponent key={idx_0} schema={inputSchema} data-sentry-element="InputComponent" data-sentry-component="_temp8" data-sentry-source-file="component.tsx" />;
}